// Fichier de traductions centralisé
// Français (langue par défaut)
export const fr = {
  // Navigation
  nav: {
    home: "Accueil",
    about: "Qui sommes-nous?",
    services: "Services",
    servicesMenu: "Nos services",
    creation: "Création d'entreprise",
    domiciliation: "Domiciliation d'entreprise",
    comptabilite: "Comptabilité",
    faq: "FAQ",
    contact: "Contact"
  },
  
  // Page d'accueil
  home: {
    hero: {
      title: "Créez votre entreprise en Tunisie",
      features: {
        support: "Accompagnement",
        simplified: "Démarches simplifiées",
        success: "Succès garanti"
      },
      price: "Prix à partir de 750 DT HT",
      rdv: "RDV en ligne",
      devis: "Devis en ligne"
    },
    whyUs: {
      title: "Pourquoi nous choisir ?",
      expertise: "Plus de 10 ans d'expertise",
      international: "Accompagnement en Tunisie & à l'international",
      fast: "Service rapide et sécurisé"
    },
    services: {
      title: "Nos formules les plus demandées",
      suarl: {
        title: "SUARL",
        subtitle: "1 associé",
        description: "à partir 1 000 TND de capital gestion simplifiée"
      },
      sarl: {
        title: "SARL",
        subtitle: "2 à 50 associés",
        description: "à partir de 1 000 TND de capital idéale PME"
      },
      sa: {
        title: "SA",
        subtitle: "7 associés et +",
        description: "pour projets d'envergure"
      },
      offshore: {
        title: "Totalement exportatrice/Off-shore",
        subtitle: "",
        description: "solutions internationales pour les non-résidents"
      }
    },
    steps: {
      title: "Notre méthode rapide en",
      colored: "4 étapes",
      step1: {
        number: "1",
        title: "Conseil personnalisé :",
        description: "Analyse de votre projet Choix de la meilleure structure"
      },
      step2: {
        number: "2",
        title: "Formalités :",
        description: "Réservations, Rédaction des statuts, Dépôt de capital, Agrément API"
      },
      step3: {
        number: "3",
        title: "Immatriculation :",
        description: "Dossier juridique Obtention matricule fiscal et inscription au RNE"
      },
      step4: {
        number: "4",
        title: "Lancement :",
        description: "Remise des documents package comptable de démarrage"
      }
    },
    faq: {
      title: "Les",
      colored: "Questions",
      end: "les plus demandés",
      button: "Découvrir plus",
      q1: {
        question: "1. Quelle forme juridique pour mon entreprise ?",
        answer1: "En Tunisie, les formes les plus courantes sont la SUARL (1 associé) et la SARL (2 à 50 associés). Les deux offrent une responsabilité limitée au capital social avec un minimum de 1 000 TND. Pour les projets d'envergure, la SA nécessite 7 associés minimum.",
        answer2: "Notre conseil : Prenez 5 minutes avec notre expert pour choisir la structure la plus adaptée à votre projet et bénéficier d'un accompagnement personnalisé."
      },
      q2: {
        question: "2. Pourquoi choisir l'une ou l'autre ?",
        answer1: "La SUARL convient aux entrepreneurs individuels avec une gestion simplifiée. La SARL est idéale pour les PME avec plusieurs associés et permet une meilleure répartition des responsabilités. La SA s'impose pour les grands projets nécessitant des investissements importants.",
        answer2: "Le choix dépend de votre nombre d'associés, du capital prévu, de votre secteur d'activité et de vos ambitions de développement. Nos experts vous guident gratuitement dans cette décision."
      },
      q3: {
        question: "3. Je suis non-résident : rapatriement des bénéfices ?",
        answer1: "Oui, les non-résidents peuvent rapatrier librement leurs bénéfices et dividendes. Pour une société totalement exportatrice, le rapatriement est garanti à 100%. Pour les autres formes, vous devez respecter la réglementation de change tunisienne.",
        answer2: "Nous vous accompagnons dans toutes les démarches auprès de la Banque Centrale de Tunisie et vous conseillons sur la meilleure structure pour faciliter vos opérations internationales."
      }
    },
    testimonials: {
      title: "Avis de nos clients",
      t1: {
        text: "Service rapide et sérieux. J'ai été très bien accompagné du début à la fin. Je recommande sans hésitation.",
        author: "Badreddine. K"
      },
      t2: {
        text: "Très disponible et à l'écoute. On se sent en confiance et bien conseillé. Je suis satisfait du service de 2S.",
        author: "Fayçal. G"
      },
      t3: {
        text: "Le cabinet m'a tout expliqué simplement et s'est occupé de la création de mon entreprise alors que je vivais à l'étranger.",
        author: "Sandro. D"
      }
    }
  },
  
  // Page À propos
  about: {
    banner: {
      title: "Nous simplifions vos démarches pour que vous vous concentriez sur l'essentiel"
    },
    content: {
      subtitle: "Qui sommes-nous ?",
      title: "Notre mission : transformer la complexité en",
      colored: "simplicité",
      p1: "Depuis 2013, 2S Consulting, société d'expertise comptable, accompagne entrepreneurs tunisiens et investisseurs internationaux dans toutes les étapes de la vie de leur société en Tunisie.",
      p2: "Avec une antenne également en France, nous combinons expertise locale et ouverture internationale pour vous offrir un accompagnement complet.",
      p3: "Nous transformons la complexité administrative et juridique en un processus simple, clair et efficace, pour que vous puissiez vous concentrer sur l'essentiel : votre projet."
    },
    services: {
      title: "Notre expertise à",
      colored: "votre service",
      s1: {
        title: "Plus de 10 ans d'expertise",
        description: "Plus de dix ans d'expérience concrète dans la création d'entreprises en Tunisie"
      },
      s2: {
        title: "Démarches simplifiées",
        description: "Maîtrise des démarches administratives et juridiques locales"
      },
      s3: {
        title: "Service rapide et sécurisé",
        description: "Anticipation des délais pour éviter toute surprise"
      }
    },
    expertise: {
      title: "Ce que nous vous",
      colored: "apportons!",
      e1: {
        title: "Gain de temps :",
        description: "Nous prenons en charge toutes les démarches, pendant que vous développez votre business"
      },
      e2: {
        title: "Sécurité juridique :",
        description: "Choix de la forme sociale adaptée, rédaction des statuts et conformité légale"
      },
      e3: {
        title: "Comptabilité & Fiscalité :",
        description: "Comptabilité, déclarations fiscales et conseils de gestion"
      }
    },
    whyUs: {
      title: "Pourquoi choisir",
      colored: "2S Consulting",
      r1: "Un accompagnement personnalisé, de l'idée initiale jusqu'au lancement",
      r2: "Tarifs transparents et communication directe avec votre interlocuteur dédié",
      r3: "Une expertise éprouvée en Tunisie et en France",
      r4: "Une solution clé en main pour démarrer sereinement"
    },
    footer: {
      title: "Votre",
      colored: "succès",
      end: "commence par des bases solides.",
      button: "Contactez-nous pour un échange gratuit"
    }
  },
  
  // Page Création d'entreprise
  serviceOne: {
    header: "Création d'entreprise",
    intro: {
      p1: "Créer son entreprise est une aventure passionnante, mais parfois semée d'embûches : choix de la forme juridique, démarches administratives, immatriculation, fiscalité…",
      p2: "Chez 2S Consulting, nous simplifions chaque étape pour transformer votre idée en projet solide, conforme et rentable."
    },
    steps: {
      title: "Notre processus en",
      colored: "4 étapes clés",
      step1: {
        number: "1",
        title: "Conseil personnalisé",
        l1: "Analyse de votre projet et de vos objectifs.",
        l2: "Recommandation sur la forme juridique la plus adaptée",
        l3: "Évaluation claire des coûts et délais"
      },
      step2: {
        number: "2",
        title: "Formalités de constitution",
        l1: "Réservation du nom de votre société",
        l2: "Rédaction et signature des statuts juridiques",
        l3: "Dépôt du capital social et déclarations nécessaires"
      },
      step3: {
        number: "3",
        title: "Immatriculation officielle",
        l1: "Dépôt du dossier au Registre National des Entreprises (RNE)",
        l2: "Obtention de l'extrait RNE et des codes fiscaux",
        l3: "Finalisation des inscriptions administratives et sociales"
      },
      step4: {
        number: "4",
        title: "Lancement réussi",
        l1: "Votre entreprise est officiellement opérationnelle",
        l2: "Remise de l'ensemble des documents légaux",
        l3: "Proposition d'un package de démarrage comptable pour bien commencer"
      }
    },
    services: {
      title: "Choisissez la structure adaptée à",
      colored: "votre projet"
    }
  },
  
  // Page Domiciliation
  serviceTwo: {
    header: "Domiciliation d'entreprise",
    intro: {
      p1: "Trouver une adresse professionnelle fiable est une étape essentielle pour la création et le développement de votre entreprise.",
      p2: "Chez 2S Consulting, nous vous facilitons cette démarche grâce à notre réseau de partenaires de domiciliation partout en Tunisie."
    },
    advantages: {
      title: "Nos avantages",
      a1: {
        title: "Choix flexible",
        description: "plusieurs adresses dans les grandes villes pour répondre à vos besoins."
      },
      a2: {
        title: "Gain de temps",
        description: "nous prenons en charge toutes les démarches administratives."
      },
      a3: {
        title: "Tarifs négociés",
        description: "nous obtenons pour vous les meilleurs prix, à partir de 40 DHTVA par mois."
      }
    },
    howItWorks: {
      title: "Comment ça marche ?",
      step1: "Vous nous indiquez vos besoins (ville, type de locaux, budget).",
      step2: "Nous sélectionnons les options adaptées parmi nos partenaires.",
      step3: "Nous négocions les tarifs et finalisons le contrat pour vous.",
      step4: "Votre entreprise dispose immédiatement d'une adresse officielle et opérationnelle."
    },
    other: {
      o1: "Réseau de partenaires dans toute la Tunisie",
      o2: "Tarifs à partir de 40 DHTVA / mois",
      o3: "Suivi complet et assistance personnalisée"
    },
    footer: {
      button: "Demandez votre domiciliation dès maintenant"
    }
  },
  
  // Page Comptabilité
  serviceThree: {
    header: "Comptabilité",
    intro: {
      p1: "La comptabilité n'est pas seulement une obligation légale : c'est un outil essentiel pour piloter et développer votre entreprise.",
      p2: "Avec 2S Consulting, vous bénéficiez d'un accompagnement sur mesure, adapté à la taille et aux besoins de votre structure"
    },
    services: {
      title: "Nos services",
      colored: "Comptables",
      s1: "Tenue et révision de comptabilité",
      s2: "Suivi de trésorerie et gestion des budgets",
      s3: "Déclarations fiscales et sociales",
      s4: "Établissement des états financiers (bilan, compte de résultat, annexes)",
      s5: "Tableaux de bord et reporting personnalisé",
      s6: "Audit comptable et assistance en cas de contrôle fiscal"
    },
    whyUs: {
      title: "Pourquoi choisir",
      colored: "2S Consulting",
      r1: "Un accompagnement personnalisé, de l'idée initiale jusqu'au lancement",
      r2: "Tarifs transparents et communication directe avec votre interlocuteur dédié",
      r3: "Une expertise éprouvée en Tunisie et en France",
      r4: "Une solution clé en main pour démarrer sereinement"
    },
    commitments: {
      title: "Nos engagements",
      c1: "Vous gagnez du temps : nous gérons vos obligations comptables et fiscales.",
      c2: "Vous réduisez vos risques : conformité garantie avec la législation tunisienne.",
      c3: "Vous prenez de meilleures décisions : accès à des tableaux de bord clairs et actualisés."
    }
  },
  
  // Page FAQ
  faq: {
    header: {
      title: "Les",
      colored: "Questions",
      end: "les plus demandés"
    },
    sections: {
      creation: {
        title: "Création d'entreprise",
        subtitle: "Démarrage simple et légal.",
        q1: {
          question: "1. Quelle forme juridique pour mon entreprise ?",
          answer1: "En Tunisie, les formes les plus courantes sont la SUARL (1 associé) et la SARL (2 à 50 associés). Les deux offrent une responsabilité limitée au capital social avec un minimum de 1 000 TND. Pour les projets d'envergure, la SA nécessite 7 associés minimum.",
          answer2: "Notre conseil : Prenez 5 minutes avec notre expert pour choisir la structure la plus adaptée à votre projet et bénéficier d'un accompagnement personnalisé."
        },
        q2: {
          question: "2. Pourquoi choisir l'une ou l'autre ?",
          answer1: "La SUARL convient aux entrepreneurs individuels avec une gestion simplifiée. La SARL est idéale pour les PME avec plusieurs associés et permet une meilleure répartition des responsabilités. La SA s'impose pour les grands projets nécessitant des investissements importants.",
          answer2: "Le choix dépend de votre nombre d'associés, du capital prévu, de votre secteur d'activité et de vos ambitions de développement. Nos experts vous guident gratuitement dans cette décision."
        }
      },
      fiscal: {
        title: "Fiscalité & obligations",
        subtitle: "Conformité et démarches simplifiées.",
        q1: {
          question: "1. Quel est le taux de l'IS en Tunisie ?",
          answer1: "Le taux standard de l'Impôt sur les Sociétés (IS) en Tunisie est de 15% pour les activités industrielles et 25% pour les services. Des taux réduits existent pour certains secteurs : agriculture (10%), exportation totale (10%), et zones de développement régional.",
          answer2: "Des avantages fiscaux sont accordés selon votre localisation et secteur d'activité. Nous vous aidons à optimiser votre fiscalité dès la création de votre entreprise."
        },
        q2: {
          question: "2. Quelles sont les obligations fiscales et sociales de mon entreprise ?",
          answer1: "Votre entreprise doit déclarer mensuellement la TVA (si applicable), la retenue à la source, et les cotisations sociales CNSS. La déclaration annuelle de l'IS est obligatoire avec dépôt des états financiers. Les employeurs doivent affilier leurs salariés à la CNSS.",
          answer2: "2S Consulting prend en charge toutes vos obligations fiscales et sociales : déclarations mensuelles, annuelles, gestion de la paie et relations avec l'administration. Concentrez-vous sur votre activité, nous gérons le reste."
        }
      },
      accounting: {
        title: "Comptabilité & services",
        subtitle: "Gestion financière sereine.",
        q1: {
          question: "1. Quels sont les tarifs de comptabilité et services offerts par votre cabinet ?",
          answer1: "Nos tarifs démarrent à partir de 150 TND/mois pour la tenue comptable basique. Nous proposons des forfaits adaptés selon votre volume d'activité : TPE, PME, ou grandes entreprises. Chaque forfait inclut les déclarations fiscales obligatoires.",
          answer2: "Demandez un devis personnalisé gratuit en ligne ou par téléphone. Nous étudions votre situation et vous proposons la formule la plus avantageuse avec un accompagnement sur mesure."
        }
      },
      investment: {
        title: "Investissement & non-résidents",
        subtitle: "Investissez en toute sécurité.",
        q1: {
          question: "1. Je suis non-résident : rapatriement des bénéfices ?",
          answer1: "Oui, les non-résidents peuvent rapatrier librement leurs bénéfices et dividendes. Pour une société totalement exportatrice, le rapatriement est garanti à 100%. Pour les autres formes, vous devez respecter la réglementation de change tunisienne.",
          answer2: "Nous vous accompagnons dans toutes les démarches auprès de la Banque Centrale de Tunisie et vous conseillons sur la meilleure structure pour faciliter vos opérations internationales."
        },
        q2: {
          question: "2. Ai-je besoin d'un compte bancaire tunisien ?",
          answer1: "Oui, l'ouverture d'un compte bancaire professionnel en Tunisie est obligatoire pour déposer le capital social et réaliser les opérations de votre entreprise. Pour les non-résidents, un compte en devises convertibles peut être ouvert.",
          answer2: "Nous vous assistons dans le choix de la banque et l'ouverture du compte. Nos partenaires bancaires facilitent les démarches pour les investisseurs étrangers avec des procédures accélérées."
        }
      }
    },
    footer: {
      title: "Vous avez une autre question ? Contactez nos experts",
      button: "Posez votre question"
    }
  },
  
  // Page Mentions Légales
  legal: {
    header: {
      title: "Mentions",
      colored: "Légales"
    },
    owner: {
      title: "PROPRIÉTAIRE DU SITE",
      company: "La société 2S Consulting SARL",
      address: "52 Avenue Othman Ibn Affan, Menzah 8, 2037 Ariana",
      phone: "Tel : +216 20 372 623",
      email: "Courriel :",
      id: "Identifiant Unique : 1279593M"
    },
    design: {
      title: "RÉALISATION GRAPHIQUE"
    },
    hosting: {
      title: "HÉBERGEMENT DU SITE",
      host: "Hébergeur : Hostinger",
      location: "Adresse : Lituanie"
    },
    conception: {
      title: "CONCEPTION DU SITE",
      designer: "Concepteur :"
    }
  },
  
  // Page Politique de Confidentialité
  privacy: {
    header: {
      title: "Politique de",
      colored: "confidentialité"
    },
    section1: {
      title: "1. Objectif",
      text: "La présente politique de confidentialité a pour objectif d'informer les utilisateurs du site 2scomptapro.com sur l'utilisation de leurs données personnelles."
    },
    section2: {
      title: "2. Données collectées",
      intro: "Les seules données susceptibles d'être collectées sont celles volontairement transmises par l'utilisateur via les formulaires de contact, notamment :",
      l1: "Nom et prénom",
      l2: "Adresse e-mail",
      l3: "Numéro de téléphone",
      l4: "Demandes du client potentiel"
    },
    section3: {
      title: "3. Absence de traitement automatisé",
      p1: "Les données collectées ne font l'objet d'aucun traitement automatisé, d'aucun profilage et d'aucune exploitation commerciale.",
      p2: "Elles sont utilisées uniquement pour :",
      l1: "Répondre à une demande d'information",
      l2: "Évaluer la possibilité d'une relation professionnelle"
    },
    section4: {
      title: "4. Conservation des données",
      p1: "En l'absence de relation contractuelle ou de collaboration effective :",
      l1: "Aucune donnée personnelle n'est conservée",
      l2: "Les informations transmises sont supprimées après traitement de la demande",
      p2: "En cas de relation de travail, les données nécessaires sont conservées conformément aux obligations légales et professionnelles en vigueur."
    },
    section5: {
      title: "5. Partage des données",
      p1: "Les données personnelles :",
      l1: "Ne sont ni vendues, ni louées, ni cédées à des tiers",
      l2: "Ne sont partagées qu'en cas de nécessité liée à la mission (administrations, partenaires professionnels), et uniquement avec l'accord de l'utilisateur"
    },
    section6: {
      title: "6. Sécurité",
      text: "Des mesures raisonnables sont mises en place afin de garantir la confidentialité et la sécurité des données transmises."
    },
    section7: {
      title: "7. Cookies",
      text: "Le site peut utiliser des cookies strictement nécessaires à son fonctionnement. Aucun cookie publicitaire ou de suivi avancé n'est utilisé."
    },
    section8: {
      title: "8. Modification",
      text: "Cette politique de confidentialité peut être modifiée à tout moment afin de rester conforme aux évolutions légales ou techniques."
    }
  },
  
  // Page Contact
  contact: {
    title: "Nous",
    colored: "contacter",
    form: {
      name: "Nom et prénom",
      email: "E-mail",
      phone: "Numéro de téléphone",
      address: "Adresse",
      needs: "Décrivez vos besoins",
      submit: "Envoyer",
      sending: "Envoi en cours...",
      success: "Message envoyé avec succès ! Nous vous contacterons bientôt.",
      error: "Erreur lors de l'envoi. Veuillez réessayer ou nous contacter directement."
    },
    info: {
      title: "Contact",
      findUs: "Nous trouver:"
    },
    map: {
      title: "Notre",
      colored: "localisation"
    }
  },
  
  // Footer
  footer: {
    description: "Avec 2S Consulting, transformez*votre idée en projet concret, sans*perdre de temps dans*les formalités.",
    quickLinks: "Accueil",
    aboutUs: "Qui sommes-nous",
    creation: "Création d'entreprise",
    domiciliation: "Domiciliation",
    accounting: "Comptabilité",
    faq: "FAQ",
    legalNotice: "Mentions légales",
    privacyPolicy: "Politique de confidentialité",
    contact: "Contact",
    organisms: "Organismes officiels",
    findUs: "Nous trouver:",
    copyright: "Tous droits réservés. Site conçu par"
  }
};

// Anglais
export const en = {
  // Navigation
  nav: {
    home: "Home",
    about: "About Us",
    services: "Services",
    servicesMenu: "Our Services",
    creation: "Company Formation",
    domiciliation: "Company Domiciliation",
    comptabilite: "Accounting",
    faq: "FAQ",
    contact: "Contact"
  },
  
  // Home Page
  home: {
    hero: {
      title: "Create your business in Tunisia",
      features: {
        support: "Support",
        simplified: "Simplified procedures",
        success: "Guaranteed success"
      },
      price: "Starting from 750 TND excl. VAT",
      rdv: "Online Appointment",
      devis: "Online Quote"
    },
    whyUs: {
      title: "Why choose us?",
      expertise: "Over 10 years of expertise",
      international: "Support in Tunisia & internationally",
      fast: "Fast and secure service"
    },
    services: {
      title: "Our most requested packages",
      suarl: {
        title: "SUARL",
        subtitle: "1 partner",
        description: "from 1,000 TND capital simplified management"
      },
      sarl: {
        title: "SARL",
        subtitle: "2 to 50 partners",
        description: "from 1,000 TND capital ideal for SMEs"
      },
      sa: {
        title: "SA",
        subtitle: "7 partners and +",
        description: "for large-scale projects"
      },
      offshore: {
        title: "Fully exporting/Off-shore",
        subtitle: "",
        description: "international solutions for non-residents"
      }
    },
    steps: {
      title: "Our fast method in",
      colored: "4 steps",
      step1: {
        number: "1",
        title: "Personalized advice:",
        description: "Analysis of your project Choice of the best structure"
      },
      step2: {
        number: "2",
        title: "Formalities:",
        description: "Reservations, Drafting of articles, Capital deposit, API approval"
      },
      step3: {
        number: "3",
        title: "Registration:",
        description: "Legal file Obtaining tax number and RNE registration"
      },
      step4: {
        number: "4",
        title: "Launch:",
        description: "Delivery of documents startup accounting package"
      }
    },
    faq: {
      title: "The most",
      colored: "frequently asked",
      end: "questions",
      button: "Discover more",
      q1: {
        question: "1. What legal form for my company?",
        answer1: "In Tunisia, the most common forms are SUARL (1 partner) and SARL (2 to 50 partners). Both offer limited liability to share capital with a minimum of 1,000 TND. For large-scale projects, SA requires a minimum of 7 partners.",
        answer2: "Our advice: Take 5 minutes with our expert to choose the most suitable structure for your project and benefit from personalized support."
      },
      q2: {
        question: "2. Why choose one or the other?",
        answer1: "SUARL is suitable for individual entrepreneurs with simplified management. SARL is ideal for SMEs with several partners and allows better distribution of responsibilities. SA is required for large projects requiring significant investments.",
        answer2: "The choice depends on your number of partners, planned capital, business sector and development ambitions. Our experts guide you free of charge in this decision."
      },
      q3: {
        question: "3. I am a non-resident: repatriation of profits?",
        answer1: "Yes, non-residents can freely repatriate their profits and dividends. For a fully exporting company, repatriation is guaranteed at 100%. For other forms, you must comply with Tunisian exchange regulations.",
        answer2: "We support you in all procedures with the Central Bank of Tunisia and advise you on the best structure to facilitate your international operations."
      }
    },
    testimonials: {
      title: "Customer reviews",
      t1: {
        text: "Fast and professional service. I was very well supported from start to finish. I recommend without hesitation.",
        author: "Badreddine. K"
      },
      t2: {
        text: "Very available and attentive. You feel confident and well advised. I am satisfied with 2S service.",
        author: "Fayçal. G"
      },
      t3: {
        text: "The firm explained everything simply and took care of creating my company while I was living abroad.",
        author: "Sandro. D"
      }
    }
  },
  
  // About Page
  about: {
    banner: {
      title: "We simplify your procedures so you can focus on what matters"
    },
    content: {
      subtitle: "Who are we?",
      title: "Our mission: transform complexity into",
      colored: "simplicity",
      p1: "Since 2013, 2S Consulting, an accounting firm, has been supporting Tunisian entrepreneurs and international investors in all stages of their company's life in Tunisia.",
      p2: "With an office also in France, we combine local expertise and international openness to offer you complete support.",
      p3: "We transform administrative and legal complexity into a simple, clear and efficient process, so you can focus on what matters: your project."
    },
    services: {
      title: "Our expertise at",
      colored: "your service",
      s1: {
        title: "Over 10 years of expertise",
        description: "More than ten years of concrete experience in creating companies in Tunisia"
      },
      s2: {
        title: "Simplified procedures",
        description: "Mastery of local administrative and legal procedures"
      },
      s3: {
        title: "Fast and secure service",
        description: "Anticipation of deadlines to avoid any surprises"
      }
    },
    expertise: {
      title: "What we bring",
      colored: "you!",
      e1: {
        title: "Time saving:",
        description: "We take care of all the procedures while you develop your business"
      },
      e2: {
        title: "Legal security:",
        description: "Choice of the appropriate corporate form, drafting of articles and legal compliance"
      },
      e3: {
        title: "Accounting & Taxation:",
        description: "Accounting, tax returns and management advice"
      }
    },
    whyUs: {
      title: "Why choose",
      colored: "2S Consulting",
      r1: "Personalized support, from the initial idea to launch",
      r2: "Transparent pricing and direct communication with your dedicated contact",
      r3: "Proven expertise in Tunisia and France",
      r4: "A turnkey solution to start with peace of mind"
    },
    footer: {
      title: "Your",
      colored: "success",
      end: "starts with solid foundations.",
      button: "Contact us for a free consultation"
    }
  },
  
  // Company Formation Page
  serviceOne: {
    header: "Company Formation",
    intro: {
      p1: "Creating your company is an exciting adventure, but sometimes fraught with pitfalls: choice of legal form, administrative procedures, registration, taxation...",
      p2: "At 2S Consulting, we simplify each step to transform your idea into a solid, compliant and profitable project."
    },
    steps: {
      title: "Our process in",
      colored: "4 key steps",
      step1: {
        number: "1",
        title: "Personalized advice",
        l1: "Analysis of your project and objectives.",
        l2: "Recommendation on the most suitable legal form",
        l3: "Clear assessment of costs and deadlines"
      },
      step2: {
        number: "2",
        title: "Formation formalities",
        l1: "Reservation of your company name",
        l2: "Drafting and signing of legal articles",
        l3: "Deposit of share capital and necessary declarations"
      },
      step3: {
        number: "3",
        title: "Official registration",
        l1: "Filing of the file with the National Register of Companies (RNE)",
        l2: "Obtaining the RNE extract and tax codes",
        l3: "Finalization of administrative and social registrations"
      },
      step4: {
        number: "4",
        title: "Successful launch",
        l1: "Your company is officially operational",
        l2: "Delivery of all legal documents",
        l3: "Proposal of a startup accounting package to start well"
      }
    },
    services: {
      title: "Choose the structure adapted to",
      colored: "your project"
    }
  },
  
  // Domiciliation Page
  serviceTwo: {
    header: "Company Domiciliation",
    intro: {
      p1: "Finding a reliable professional address is an essential step for the creation and development of your company.",
      p2: "At 2S Consulting, we make this process easier thanks to our network of domiciliation partners throughout Tunisia."
    },
    advantages: {
      title: "Our advantages",
      a1: {
        title: "Flexible choice",
        description: "several addresses in major cities to meet your needs."
      },
      a2: {
        title: "Time saving",
        description: "we take care of all administrative procedures."
      },
      a3: {
        title: "Negotiated rates",
        description: "we get you the best prices, from 40 TND excl. VAT per month."
      }
    },
    howItWorks: {
      title: "How does it work?",
      step1: "You tell us your needs (city, type of premises, budget).",
      step2: "We select suitable options from our partners.",
      step3: "We negotiate rates and finalize the contract for you.",
      step4: "Your company immediately has an official and operational address."
    },
    other: {
      o1: "Network of partners throughout Tunisia",
      o2: "Rates from 40 TND excl. VAT / month",
      o3: "Complete follow-up and personalized assistance"
    },
    footer: {
      button: "Request your domiciliation now"
    }
  },
  
  // Accounting Page
  serviceThree: {
    header: "Accounting",
    intro: {
      p1: "Accounting is not just a legal obligation: it is an essential tool to manage and develop your business.",
      p2: "With 2S Consulting, you benefit from tailor-made support, adapted to the size and needs of your structure"
    },
    services: {
      title: "Our",
      colored: "Accounting",
      end: "services",
      s1: "Bookkeeping and accounting review",
      s2: "Cash flow monitoring and budget management",
      s3: "Tax and social declarations",
      s4: "Preparation of financial statements (balance sheet, income statement, annexes)",
      s5: "Dashboards and personalized reporting",
      s6: "Accounting audit and assistance in case of tax audit"
    },
    whyUs: {
      title: "Why choose",
      colored: "2S Consulting",
      r1: "Personalized support, from the initial idea to launch",
      r2: "Transparent pricing and direct communication with your dedicated contact",
      r3: "Proven expertise in Tunisia and France",
      r4: "A turnkey solution to start with peace of mind"
    },
    commitments: {
      title: "Our commitments",
      c1: "You save time: we manage your accounting and tax obligations.",
      c2: "You reduce your risks: compliance guaranteed with Tunisian legislation.",
      c3: "You make better decisions: access to clear and updated dashboards."
    }
  },
  
  // FAQ Page
  faq: {
    header: {
      title: "The most",
      colored: "frequently asked",
      end: "questions"
    },
    sections: {
      creation: {
        title: "Company Formation",
        subtitle: "Simple and legal startup.",
        q1: {
          question: "1. What legal form for my company?",
          answer1: "In Tunisia, the most common forms are SUARL (1 partner) and SARL (2 to 50 partners). Both offer limited liability to share capital with a minimum of 1,000 TND. For large-scale projects, SA requires a minimum of 7 partners.",
          answer2: "Our advice: Take 5 minutes with our expert to choose the most suitable structure for your project and benefit from personalized support."
        },
        q2: {
          question: "2. Why choose one or the other?",
          answer1: "SUARL is suitable for individual entrepreneurs with simplified management. SARL is ideal for SMEs with several partners and allows better distribution of responsibilities. SA is required for large projects requiring significant investments.",
          answer2: "The choice depends on your number of partners, planned capital, business sector and development ambitions. Our experts guide you free of charge in this decision."
        }
      },
      fiscal: {
        title: "Taxation & obligations",
        subtitle: "Compliance and simplified procedures.",
        q1: {
          question: "1. What is the corporate tax rate in Tunisia?",
          answer1: "The standard corporate tax rate in Tunisia is 15% for industrial activities and 25% for services. Reduced rates exist for certain sectors: agriculture (10%), total export (10%), and regional development zones.",
          answer2: "Tax advantages are granted according to your location and business sector. We help you optimize your taxation from the creation of your company."
        },
        q2: {
          question: "2. What are the tax and social obligations of my company?",
          answer1: "Your company must declare monthly VAT (if applicable), withholding tax, and CNSS social contributions. The annual corporate tax return is mandatory with filing of financial statements. Employers must affiliate their employees with CNSS.",
          answer2: "2S Consulting takes care of all your tax and social obligations: monthly, annual declarations, payroll management and relations with the administration. Focus on your activity, we manage the rest."
        }
      },
      accounting: {
        title: "Accounting & services",
        subtitle: "Serene financial management.",
        q1: {
          question: "1. What are the accounting rates and services offered by your firm?",
          answer1: "Our rates start from 150 TND/month for basic bookkeeping. We offer packages adapted to your volume of activity: VSE, SME, or large companies. Each package includes mandatory tax returns.",
          answer2: "Request a free personalized quote online or by phone. We study your situation and offer you the most advantageous formula with tailor-made support."
        }
      },
      investment: {
        title: "Investment & non-residents",
        subtitle: "Invest safely.",
        q1: {
          question: "1. I am a non-resident: repatriation of profits?",
          answer1: "Yes, non-residents can freely repatriate their profits and dividends. For a fully exporting company, repatriation is guaranteed at 100%. For other forms, you must comply with Tunisian exchange regulations.",
          answer2: "We support you in all procedures with the Central Bank of Tunisia and advise you on the best structure to facilitate your international operations."
        },
        q2: {
          question: "2. Do I need a Tunisian bank account?",
          answer1: "Yes, opening a professional bank account in Tunisia is mandatory to deposit share capital and carry out your company's operations. For non-residents, a convertible currency account can be opened.",
          answer2: "We assist you in choosing the bank and opening the account. Our banking partners facilitate procedures for foreign investors with accelerated procedures."
        }
      }
    },
    footer: {
      title: "Do you have another question? Contact our experts",
      button: "Ask your question"
    }
  },
  
  // Legal Notice Page
  legal: {
    header: {
      title: "Legal",
      colored: "Notice"
    },
    owner: {
      title: "SITE OWNER",
      company: "The company 2S Consulting SARL",
      address: "52 Avenue Othman Ibn Affan, Menzah 8, 2037 Ariana",
      phone: "Tel: +216 20 372 623",
      email: "Email:",
      id: "Unique Identifier: 1279593M"
    },
    design: {
      title: "GRAPHIC DESIGN"
    },
    hosting: {
      title: "SITE HOSTING",
      host: "Host: Hostinger",
      location: "Address: Lithuania"
    },
    conception: {
      title: "SITE DESIGN",
      designer: "Designer:"
    }
  },
  
  // Privacy Policy Page
  privacy: {
    header: {
      title: "Privacy",
      colored: "Policy"
    },
    section1: {
      title: "1. Purpose",
      text: "The purpose of this privacy policy is to inform users of the 2scomptapro.com site about the use of their personal data."
    },
    section2: {
      title: "2. Data collected",
      intro: "The only data that may be collected is that voluntarily transmitted by the user via contact forms, including:",
      l1: "First and last name",
      l2: "Email address",
      l3: "Phone number",
      l4: "Potential customer requests"
    },
    section3: {
      title: "3. No automated processing",
      p1: "The collected data is not subject to any automated processing, profiling or commercial exploitation.",
      p2: "They are used only to:",
      l1: "Respond to a request for information",
      l2: "Assess the possibility of a professional relationship"
    },
    section4: {
      title: "4. Data retention",
      p1: "In the absence of a contractual relationship or effective collaboration:",
      l1: "No personal data is retained",
      l2: "The information transmitted is deleted after processing the request",
      p2: "In case of a working relationship, the necessary data is retained in accordance with legal and professional obligations in force."
    },
    section5: {
      title: "5. Data sharing",
      p1: "Personal data:",
      l1: "Is neither sold, rented, nor transferred to third parties",
      l2: "Is only shared in case of necessity related to the mission (administrations, professional partners), and only with the user's consent"
    },
    section6: {
      title: "6. Security",
      text: "Reasonable measures are in place to ensure the confidentiality and security of transmitted data."
    },
    section7: {
      title: "7. Cookies",
      text: "The site may use cookies strictly necessary for its operation. No advertising or advanced tracking cookies are used."
    },
    section8: {
      title: "8. Modification",
      text: "This privacy policy may be modified at any time to remain compliant with legal or technical developments."
    }
  },
  
  // Contact Page
  contact: {
    title: "Contact",
    colored: "us",
    form: {
      name: "Full name",
      email: "Email",
      phone: "Phone number",
      address: "Address",
      needs: "Describe your needs",
      submit: "Send",
      sending: "Sending...",
      success: "Message sent successfully! We will contact you soon.",
      error: "Error sending. Please try again or contact us directly."
    },
    info: {
      title: "Contact",
      findUs: "Find us:"
    },
    map: {
      title: "Our",
      colored: "location"
    }
  },
  
  // Footer
  footer: {
    description: "With 2S Consulting, transform*your idea into a concrete project,*without wasting time*on formalities.",
    quickLinks: "Home",
    aboutUs: "About Us",
    creation: "Company Formation",
    domiciliation: "Domiciliation",
    accounting: "Accounting",
    faq: "FAQ",
    legalNotice: "Legal Notice",
    privacyPolicy: "Privacy Policy",
    contact: "Contact",
    organisms: "Official Organizations",
    findUs: "Find us:",
    copyright: "All rights reserved. Site designed by"
  }
};
